var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkEmpty = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#DFDFE0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_998_1733",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 76,
    height: 76
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37.6524,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_998_1733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5058 46.683L46.682 33.5051M37.8979 26.9162L38.9147 25.739C40.9741 23.6796 43.7672 22.5227 46.6795 22.5229C49.5918 22.5232 52.3848 23.6804 54.444 25.7401C56.5031 27.7998 57.6598 30.5933 57.6596 33.5059C57.6594 36.4186 56.5023 39.2119 54.4429 41.2713L53.2702 42.2904M42.29 53.2719L41.4181 54.4447C39.3341 56.5042 36.5224 57.6591 33.5926 57.6591C30.6627 57.6591 27.851 56.5042 25.767 54.4447C24.7395 53.4294 23.9237 52.2203 23.3669 50.8874C22.8101 49.5544 22.5234 48.1242 22.5234 46.6797C22.5234 45.2351 22.8101 43.8049 23.3669 42.472C23.9237 41.1391 24.7395 39.9299 25.767 38.9146L26.9177 37.8977",
    stroke: "white",
    strokeWidth: 4.39202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link-empty.b12a3d4b.svg";
export { ForwardRef as ReactComponent };